import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import type { TFunction } from 'i18next'
import { SelectableCardList, type SelectableCardData } from '~/widgets'
import { allowLabelType, type CountryCode, type ReturnPortal, type LabelType } from '~/model'
import { LabelTypeDetailInfo } from '~/components'
import { insertIf } from '~/helpers'

type ItemType = SelectableCardData<LabelType>

export const getLabelTypeItems = (
  returnPortal: ReturnPortal,
  countryCode: CountryCode,
  t: TFunction
): [ItemType[], LabelType | undefined] => {
  const showQrItem = allowLabelType(returnPortal, countryCode)
  const items = [
    ...insertIf<ItemType>(showQrItem, {
      label: t('qrCodeLabel'),
      description: t('qrCodeDescription'),
      value: 'QrCode',
      iconName: 'PrintlessGoGreen',
    }),
    {
      label: t('printLabelLabel'),
      description: t('printLabelDescription'),
      value: 'PrintedLabel',
      iconName: 'LabelPrinter',
    },
  ] as ItemType[]
  const defaultValue = items.length === 1 ? items[0].value : undefined
  return [items, defaultValue]
}

type Props = {
  returnPortal: ReturnPortal
  countryCode: CountryCode
  showRequiredDataLabel: boolean
}

export const LabelTypeInput = ({ returnPortal, countryCode, showRequiredDataLabel }: Props) => {
  const { t } = useTranslation()
  const [items] = getLabelTypeItems(returnPortal, countryCode, t)
  const [, { value }] = useField('returnDeclarationMechanism')

  return (
    <>
      <SelectableCardList<LabelType>
        fieldName="returnDeclarationMechanism"
        showRequiredDataLabel={showRequiredDataLabel}
        title={t('chooseLabelType')}
        items={items}
      />
      {!showRequiredDataLabel && <LabelTypeDetailInfo value={value} items={items} />}
    </>
  )
}
